import { createResource } from 'react-resource-router';
import { assert, AssertionError } from '@atlassian/eoc-common';
import { isTeamReportsUrl } from '../../common/utils';
import { getDashboards, getReportRights, getReportSettings } from '../endpoints';
export const opsReportsResource = createResource({
  type: 'opsReportsResource',
  getKey: () => 'opsReportsResource',
  getData: async () => {
    const settings = await getReportSettings();
    const api = getDashboards;
    return {
      settings,
      dashboards: settings.showReportingMaintenance ? null : await api()
    };
  },
  maxAge: Infinity,
  isBrowserOnly: true
});
export const opsReportsPermissionResource = createResource({
  type: 'opsReportsPermissionResource',
  getKey: ({
    match
  }) => {
    var _match$params;
    return `opsReportsPermissionResource-${(_match$params = match.params) === null || _match$params === void 0 ? void 0 : _match$params.teamId}`;
  },
  getData: async routerContext => {
    var _routerContext$match$;
    const isTeamDashboard = isTeamReportsUrl(routerContext.match.url);
    const teamId = (_routerContext$match$ = routerContext.match.params) === null || _routerContext$match$ === void 0 ? void 0 : _routerContext$match$.teamId;
    assert(!isTeamDashboard || !!teamId, new AssertionError('opsReportsPermissionResource', 'teamId should be set to fetch reports permissions on TeamDashboard page'));
    return getReportRights(teamId);
  },
  isBrowserOnly: true,
  maxAge: Infinity
});
export const resources = [opsReportsResource];